module.exports = function() {
  return new Worker(__webpack_public_path__ + "0f12877c107e6fd72d1f.worker.js");
};